import { render, staticRenderFns } from "./Event2Form.vue?vue&type=template&id=77b9b6ce&"
import script from "./Event2Form.vue?vue&type=script&lang=js&"
export * from "./Event2Form.vue?vue&type=script&lang=js&"
import style0 from "./Event2Form.vue?vue&type=style&index=0&id=77b9b6ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports